export default __webpack_public_path__ + "static/media/icon_authenticate.e247476a.svg";